import React from 'react';
import PropTypes from 'prop-types';
import {renderMarkdown, getText} from 'helpers/text-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import Button from 'components/ui/button/button';
import './game-experiment-presentation.scss';

const GameExperimentPresentation = ({languageId, deviceInfo, goToPage}) => {
	return (
		<div className={'GameExperimentPresentation ' + deviceInfo.orientation}>

			{/* Home btn */}
			<div className="GameExperimentPresentation-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			<div className="GameExperimentPresentation-content">
				{/* Game progress */}
				<GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>

				<div className="GameExperimentPresentation-title">
					<span>{getText('pages_experimentPresentationTitle', languageId)}</span>
				</div>
				<div className="GameExperimentPresentation-text">
					{renderMarkdown(getText('pages_experimentPresentationText', languageId))}
				</div>
			</div>

			<div className="GameExperimentPresentation-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-experiment');}}
				/>
			</div>
			<div className="GameExperimentPresentation-nextBtn">
				<Button 
					classes={['orange', 'next', 'fullHeight']}
					text={getText('general_next', languageId)}
					onClick={() => {goToPage('game-end');}}
				/>
			</div>
		</div>
	);
};

GameExperimentPresentation.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameExperimentPresentation;